/**
 * Checkout Form Customization Script
 * تخصيص نموذج الدفع
 * 
 * هذا السكريبت يبسط نموذج الدفع لعرض:
 * - الاسم الكامل
 * - رقم الهاتف للتواصل
 * - العنوان
 * 
 * طريقة الاستخدام:
 * 1. اذهب إلى Shopify Admin > Settings > Checkout
 * 2. انتقل إلى قسم "Order processing"
 * 3. في مربع "Additional scripts" الصق محتوى هذا الملف
 * 4. احفظ التغييرات
 */

(function() {
  'use strict';
  
  // تحقق من أننا في صفحة checkout
  if (!window.location.hostname.includes('checkout') && 
      !window.location.pathname.includes('/checkouts/') &&
      !window.location.pathname.includes('/cart')) {
    // إذا لم نكن في checkout أو cart، لا نفعل شيء
    return;
  }

  function hideField(selector) {
    try {
      const elements = document.querySelectorAll(selector);
      elements.forEach(function(element) {
        if (element) {
          // Find the parent field wrapper - try multiple selectors
          let fieldWrapper = element.closest('.field') || 
                            element.closest('.fieldset') || 
                            element.closest('.section__content') ||
                            element.closest('.input-wrapper') ||
                            element.closest('.field__input-wrapper') ||
                            element.closest('[class*="field"]') ||
                            element.closest('[class*="Field"]') ||
                            element.closest('div[class*="input"]') ||
                            element.closest('div[class*="Input"]') ||
                            element.closest('div[class*="form"]') ||
                            element.closest('div[class*="Form"]') ||
                            element.parentElement;
          
          if (fieldWrapper) {
            // Multiple hiding methods
            fieldWrapper.style.display = 'none !important';
            fieldWrapper.style.visibility = 'hidden !important';
            fieldWrapper.style.height = '0 !important';
            fieldWrapper.style.overflow = 'hidden !important';
            fieldWrapper.style.margin = '0 !important';
            fieldWrapper.style.padding = '0 !important';
            fieldWrapper.style.opacity = '0';
            fieldWrapper.setAttribute('hidden', 'true');
            fieldWrapper.classList.add('hidden');
            
            // Remove required attribute if present
            if (element.hasAttribute('required')) {
              element.removeAttribute('required');
              element.setAttribute('aria-required', 'false');
            }
            
            // Also hide label if exists
            const label = fieldWrapper.querySelector('label');
            if (label) {
              label.style.display = 'none';
              label.style.visibility = 'hidden';
            }
          }
          
          // Also hide the element itself with multiple methods
          element.style.display = 'none !important';
          element.style.visibility = 'hidden !important';
          element.style.height = '0';
          element.style.overflow = 'hidden';
          element.setAttribute('hidden', 'true');
          element.classList.add('hidden');
          
          // Remove from tab order
          element.setAttribute('tabindex', '-1');
        }
      });
    } catch (e) {
      console.log('Error hiding field:', selector, e);
    }
  }

  function makeRequired(selector) {
    const elements = document.querySelectorAll(selector);
    elements.forEach(function(element) {
      if (element && !element.hasAttribute('required')) {
        element.setAttribute('required', 'required');
        element.setAttribute('aria-required', 'true');
      }
    });
  }

  function updateLabel(selector, newText) {
    const field = document.querySelector(selector);
    if (field) {
      const label = field.closest('.field')?.querySelector('label') ||
                   field.closest('.fieldset')?.querySelector('label') ||
                   field.previousElementSibling;
      if (label) {
        label.textContent = newText;
      }
    }
  }

  function initCheckoutCustomization() {
    // Hide ALL unnecessary fields - keep ONLY: Full Name, Phone, Address
    
    // ===== Hide Contact Section Completely =====
    const contactSections = document.querySelectorAll(
      '[class*="contact"]:not([class*="delivery"]), ' +
      '[class*="Contact"]:not([class*="Delivery"]), ' +
      'section:has(input[type="email"]):not(:has(input[type="tel"])), ' +
      'div:has(input[type="email"]):not(:has(input[type="tel"]))'
    );
    contactSections.forEach(function(section) {
      const sectionText = (section.textContent || '').toLowerCase();
      if (sectionText.includes('contact') && !sectionText.includes('delivery')) {
        section.style.display = 'none';
        section.style.visibility = 'hidden';
        section.style.height = '0';
        section.style.overflow = 'hidden';
        section.style.margin = '0';
        section.style.padding = '0';
        section.setAttribute('aria-hidden', 'true');
        section.setAttribute('hidden', 'true');
      }
    });
    
    // ===== Hide "Sign in" text/link =====
    // Method 1: Hide by text content
    const allElements = document.querySelectorAll('*');
    allElements.forEach(function(element) {
      // Skip script and style tags
      if (element.tagName === 'SCRIPT' || element.tagName === 'STYLE') {
        return;
      }
      
      const text = (element.textContent || '').trim();
      const textLower = text.toLowerCase();
      
      // Check if element contains "sign in" text
      if ((textLower.includes('sign in') || 
           textLower.includes('signin') ||
           textLower === 'sign in') &&
          !textLower.includes('delivery') &&
          !textLower.includes('address')) {
        
        // Don't hide if it's inside a larger element that we want to keep
        const parent = element.parentElement;
        if (parent && (parent.textContent || '').toLowerCase().includes('delivery')) {
          return;
        }
        
        // Hide the element
        element.style.display = 'none';
        element.style.visibility = 'hidden';
        element.style.height = '0';
        element.style.overflow = 'hidden';
        element.style.margin = '0';
        element.style.padding = '0';
        element.setAttribute('aria-hidden', 'true');
        element.setAttribute('hidden', 'true');
      }
    });
    
    // Method 2: Hide Sign in links specifically
    const allLinks = document.querySelectorAll('a');
    allLinks.forEach(function(link) {
      const linkText = (link.textContent || '').toLowerCase().trim();
      const linkHref = (link.getAttribute('href') || '').toLowerCase();
      
      if (linkText.includes('sign in') || 
          linkText.includes('signin') || 
          linkText.includes('login') ||
          linkHref.includes('/account') ||
          linkHref.includes('/login')) {
        const wrapper = link.closest('div') || 
                       link.closest('section') || 
                       link.closest('p') ||
                       link.closest('span') ||
                       link.parentElement;
        if (wrapper) {
          wrapper.style.display = 'none';
          wrapper.style.visibility = 'hidden';
          wrapper.style.height = '0';
          wrapper.style.overflow = 'hidden';
          wrapper.style.margin = '0';
          wrapper.style.padding = '0';
          wrapper.setAttribute('aria-hidden', 'true');
          wrapper.setAttribute('hidden', 'true');
        }
      }
    });
    
    // Method 3: Hide by class names that might contain "sign" or "login"
    const signInElements = document.querySelectorAll(
      '[class*="sign-in"], ' +
      '[class*="signin"], ' +
      '[class*="login"], ' +
      '[id*="sign-in"], ' +
      '[id*="signin"], ' +
      '[id*="login"]'
    );
    signInElements.forEach(function(element) {
      const elementText = (element.textContent || '').toLowerCase();
      if (elementText.includes('sign in') || 
          elementText.includes('signin') || 
          elementText.includes('login')) {
        const wrapper = element.closest('div') || 
                       element.closest('section') || 
                       element.parentElement;
        if (wrapper && !wrapper.textContent.toLowerCase().includes('delivery')) {
          wrapper.style.display = 'none';
          wrapper.style.visibility = 'hidden';
          wrapper.style.height = '0';
          wrapper.style.overflow = 'hidden';
          wrapper.setAttribute('aria-hidden', 'true');
          wrapper.setAttribute('hidden', 'true');
        }
      }
    });
    
    // Hide Email Field
    hideField('[name*="[email]"]');
    hideField('[name*="email"]');
    hideField('[name*="checkout[email]"]');
    hideField('#checkout_email');
    hideField('.field--email');
    hideField('[data-checkout-field="email"]');
    hideField('input[type="email"]');
    hideField('input[placeholder*="Email"]');
    hideField('input[placeholder*="email"]');
    
    // Hide Contact heading
    const headings = document.querySelectorAll('h2, h3, h4, .heading, [class*="heading"]');
    headings.forEach(function(heading) {
      const headingText = (heading.textContent || '').toLowerCase();
      if (headingText.includes('contact') && !headingText.includes('delivery')) {
        const section = heading.closest('section') || heading.closest('div');
        if (section && !section.querySelector('input[type="tel"]')) {
          section.style.display = 'none';
        }
      }
    });
    
    // ===== Hide Company Field =====
    hideField('[name*="[company]"]');
    hideField('[name*="company"]');
    hideField('.field--company');
    hideField('[data-address-field="company"]');
    hideField('[data-checkout-field="company"]');
    hideField('[id*="company"]');
    hideField('input[placeholder*="Company"]');
    hideField('input[placeholder*="company"]');
    
    // ===== Hide Address Line 2 =====
    hideField('[name*="[address2]"]');
    hideField('[name*="address2"]');
    hideField('[name*="checkout[shipping_address][address2]"]');
    hideField('.field--address2');
    hideField('[data-address-field="address2"]');
    hideField('[data-checkout-field="address2"]');
    hideField('[id*="address2"]');
    hideField('input[placeholder*="Apartment"]');
    hideField('input[placeholder*="apartment"]');
    hideField('input[placeholder*="Address line 2"]');
    
    // ===== Show City (we need to update its label) =====
    // Don't hide city - we need to show it with Arabic label

    // ===== Show Province/State (we need to update its label) =====
    // Don't hide province - we need to show it with Arabic label

    // ===== Show Postal/ZIP Code (we need to update its label) =====
    // Don't hide postal code - we need to show it with Arabic label
    
    // ===== Hide Country Selector =====
    hideField('[name*="[country]"]');
    hideField('[name*="country"]');
    hideField('[name*="checkout[shipping_address][country]"]');
    hideField('.field--country');
    hideField('[data-address-field="country"]');
    hideField('[data-checkout-field="country"]');
    hideField('select[name*="country"]');
    hideField('[id*="country"]');
    
    // ===== Hide Billing Address Section =====
    const billingSections = document.querySelectorAll(
      '[class*="billing"], ' +
      '[class*="Billing"], ' +
      '[id*="billing"], ' +
      'section:has([class*="billing-address"]), ' +
      'div:has([class*="billing-address"])'
    );
    billingSections.forEach(function(section) {
      const sectionText = (section.textContent || '').toLowerCase();
      if (sectionText.includes('billing') || 
          sectionText.includes('different billing') ||
          sectionText.includes('use a different')) {
        section.style.display = 'none';
        section.style.visibility = 'hidden';
        section.style.height = '0';
        section.style.overflow = 'hidden';
      }
    });
    
    // Hide "Same as shipping address" checkbox
    hideField('input[type="checkbox"][name*="billing"]');
    hideField('input[type="checkbox"][id*="billing"]');
    hideField('input[type="checkbox"]:has(+ label:contains("billing"))');
    
    // ===== Hide "Save this information" checkbox =====
    hideField('input[type="checkbox"][name*="save"]');
    hideField('input[type="checkbox"][id*="save"]');
    const saveCheckboxes = document.querySelectorAll('input[type="checkbox"]');
    saveCheckboxes.forEach(function(checkbox) {
      const label = checkbox.nextElementSibling || checkbox.parentElement.querySelector('label');
      if (label && (label.textContent.toLowerCase().includes('save') || 
                    label.textContent.toLowerCase().includes('remember'))) {
        const wrapper = checkbox.closest('.field') || 
                       checkbox.closest('div') ||
                       checkbox.parentElement;
        if (wrapper) {
          wrapper.style.display = 'none';
        }
      }
    });
    
    // ===== Make sure ONLY required fields are marked =====
    makeRequired('[name*="[first_name]"]');
    makeRequired('[name*="[phone]"]');
    makeRequired('[name*="[address1]"]');
    
    // Remove required from last_name since we're hiding it
    const lastNameFields = document.querySelectorAll('[name*="[last_name]"]');
    lastNameFields.forEach(function(field) {
      if (field.hasAttribute('required')) {
        field.removeAttribute('required');
        field.setAttribute('aria-required', 'false');
      }
    });
    
    // Remove required from hidden fields
    const hiddenSelectors = [
      '[name*="[company]"]',
      '[name*="[address2]"]',
      '[name*="[city]"]',
      '[name*="[province]"]',
      '[name*="[zip]"]',
      '[name*="[postal]"]',
      '[name*="[country]"]',
      '[name*="[email]"]',
      '[name*="email"]',
      '[name*="[last_name]"]',
      '[name*="last_name"]'
    ];
    
    hiddenSelectors.forEach(function(selector) {
      const fields = document.querySelectorAll(selector);
      fields.forEach(function(field) {
        if (field.hasAttribute('required')) {
          field.removeAttribute('required');
          field.setAttribute('aria-required', 'false');
        }
      });
    });
    
    // ===== Change Contact Section Title =====
    const contactHeadings = document.querySelectorAll('h2, h3, h4, .heading, [class*="heading"], [class*="section-title"]');
    contactHeadings.forEach(function(heading) {
      const headingText = (heading.textContent || '').toLowerCase();
      if (headingText.includes('contact') && !headingText.includes('delivery')) {
        heading.textContent = 'رقم الهاتف / رقم الواتساب';
      }
    });
    
    // ===== Change Delivery Section Title =====
    const deliveryHeadings = document.querySelectorAll('h2, h3, h4, .heading, [class*="heading"], [class*="section-title"]');
    deliveryHeadings.forEach(function(heading) {
      const headingText = (heading.textContent || '').toLowerCase();
      if (headingText.includes('delivery') || headingText.includes('shipping address')) {
        heading.textContent = '🚚 اكتب بيانات الشحن علشان طلبك يوصلك لحد باب البيت بكل سهولة.';
      }
    });
    
    // Also try to find delivery section by content
    const allSections = document.querySelectorAll('section, div[class*="section"], div[class*="step"]');
    allSections.forEach(function(section) {
      const sectionText = (section.textContent || '').toLowerCase();
      if ((sectionText.includes('delivery') || sectionText.includes('shipping address')) && 
          section.querySelector('input[name*="first_name"]')) {
        const heading = section.querySelector('h2, h3, h4, .heading, [class*="heading"]');
        if (heading) {
          heading.textContent = '🚚 اكتب بيانات الشحن علشان طلبك يوصلك لحد باب البيت بكل سهولة.';
        }
      }
    });
    
    // ===== Update Email/Phone placeholder =====
    const emailInputs = document.querySelectorAll('input[type="email"], input[name*="email"], input[placeholder*="Email"], input[placeholder*="email"], input[placeholder*="mobile"], input[placeholder*="phone"]');
    emailInputs.forEach(function(input) {
      const placeholder = (input.getAttribute('placeholder') || '').toLowerCase();
      if (placeholder.includes('email') || placeholder.includes('mobile') || placeholder.includes('phone')) {
        input.setAttribute('placeholder', 'رقم الهاتف');
      }
    });
    
    // ===== Update labels to Arabic =====
    updateLabel('[name*="[first_name]"]', 'الإسم الأول');
    updateLabel('[name*="[last_name]"]', 'اسم العائلة');
    updateLabel('[name*="[phone]"]', 'رقم الهاتف للتواصل');
    updateLabel('[name*="[address1]"]', 'العنوان');
    updateLabel('[name*="[city]"]', 'المدينة');
    updateLabel('[name*="[province]"], [name*="[state]"]', 'المحافظة');
    updateLabel('[name*="[zip]"], [name*="[postal]"]', 'رقم هاتف بديل');
    
    // ===== Update placeholders =====
    const firstNameInputs = document.querySelectorAll('input[name*="first_name"], input[placeholder*="First name"], input[placeholder*="first name"]');
    firstNameInputs.forEach(function(input) {
      input.setAttribute('placeholder', 'الإسم الأول');
    });
    
    const lastNameInputs = document.querySelectorAll('input[name*="last_name"], input[placeholder*="Last name"], input[placeholder*="last name"]');
    lastNameInputs.forEach(function(input) {
      input.setAttribute('placeholder', 'اسم العائلة');
    });
    
    const addressInputs = document.querySelectorAll('input[name*="address1"], input[placeholder*="Address"], input[placeholder*="address"]');
    addressInputs.forEach(function(input) {
      const placeholder = (input.getAttribute('placeholder') || '').toLowerCase();
      if (!placeholder.includes('line 2') && !placeholder.includes('apartment')) {
        input.setAttribute('placeholder', 'العنوان');
      }
    });
    
    const cityInputs = document.querySelectorAll('input[name*="city"], input[placeholder*="City"], input[placeholder*="city"]');
    cityInputs.forEach(function(input) {
      input.setAttribute('placeholder', 'المدينة');
    });
    
    const provinceInputs = document.querySelectorAll('input[name*="province"], input[name*="state"], select[name*="province"], select[name*="state"], input[placeholder*="Province"], input[placeholder*="State"]');
    provinceInputs.forEach(function(input) {
      input.setAttribute('placeholder', 'المحافظة');
    });
    
    const postalInputs = document.querySelectorAll('input[name*="zip"], input[name*="postal"], input[placeholder*="Postal"], input[placeholder*="ZIP"]');
    postalInputs.forEach(function(input) {
      input.setAttribute('placeholder', 'رقم هاتف بديل');
    });
    
    // ===== Update Complete Order button =====
    const completeOrderButtons = document.querySelectorAll('button[type="submit"], button:contains("Complete order"), button:contains("complete order"), [class*="step__footer"] button, [class*="step__footer"] input[type="submit"]');
    completeOrderButtons.forEach(function(button) {
      const buttonText = (button.textContent || button.value || '').toLowerCase();
      if (buttonText.includes('complete order') || buttonText.includes('place order') || buttonText.includes('submit order')) {
        if (button.tagName === 'INPUT') {
          button.setAttribute('value', 'أكد الطلب');
        } else {
          button.textContent = 'أكد الطلب';
        }
      }
    });
    
    // Also check for buttons by class or data attributes
    const submitButtons = document.querySelectorAll('[data-step="payment_method"] button[type="submit"], .step__footer__continue-btn, .step__footer button');
    submitButtons.forEach(function(button) {
      const buttonText = (button.textContent || button.value || '').trim();
      if (buttonText.toLowerCase().includes('complete') || buttonText.toLowerCase().includes('order') || buttonText.toLowerCase().includes('place')) {
        if (button.tagName === 'INPUT') {
          button.setAttribute('value', 'أكد الطلب');
        } else {
          button.textContent = 'أكد الطلب';
        }
      }
    });
    
    // ===== Show Last Name Field (we need to update its label) =====
    // Don't hide last name - we need to show it with Arabic label
    
    // ===== Hide any additional fields that might appear =====
    // Hide any field with "optional" in its text
    const allLabels = document.querySelectorAll('label');
    allLabels.forEach(function(label) {
      const labelText = label.textContent.toLowerCase();
      if (labelText.includes('optional') || 
          labelText.includes('company') || 
          labelText.includes('apartment') ||
          labelText.includes('address line 2') ||
          (labelText.includes('city') && !labelText.includes('address')) ||
          labelText.includes('province') ||
          labelText.includes('state') ||
          labelText.includes('postal') ||
          labelText.includes('zip code') ||
          labelText.includes('region') ||
          labelText.includes('area')) {
        const field = label.closest('.field') || 
                     label.closest('.fieldset') ||
                     label.closest('div') ||
                     label.parentElement;
        if (field) {
          field.style.display = 'none';
          field.style.visibility = 'hidden';
          field.style.height = '0';
          field.style.overflow = 'hidden';
          field.style.margin = '0';
          field.style.padding = '0';
        }
      }
    });
    
    // ===== Hide by data attributes =====
    const allFields = document.querySelectorAll('[data-address-field], [data-field], [class*="field"]');
    allFields.forEach(function(field) {
      const fieldName = (field.getAttribute('data-address-field') || 
                        field.getAttribute('data-field') || 
                        field.className || '').toLowerCase();
      
      if (fieldName.includes('company') ||
          fieldName.includes('address2') ||
          fieldName.includes('apartment') ||
          (fieldName.includes('city') && !fieldName.includes('address')) ||
          fieldName.includes('province') ||
          fieldName.includes('state') ||
          fieldName.includes('postal') ||
          fieldName.includes('zip')) {
        const wrapper = field.closest('.field') || 
                       field.closest('.fieldset') ||
                       field.closest('div') ||
                       field;
        wrapper.style.display = 'none';
        wrapper.style.visibility = 'hidden';
      }
    });
    
    // ===== Force hide specific Shopify checkout classes =====
    const shopifyClasses = [
      '.field--company',
      '.field--address2',
      '.field--city',
      '.field--province',
      '.field--state',
      '.field--zip',
      '.field--postal',
      '.field--country',
      '[data-checkout-field="company"]',
      '[data-checkout-field="address2"]',
      '[data-checkout-field="city"]',
      '[data-checkout-field="province"]',
      '[data-checkout-field="zip"]'
    ];
    
    shopifyClasses.forEach(function(selector) {
      const elements = document.querySelectorAll(selector);
      elements.forEach(function(el) {
        el.style.display = 'none';
        el.style.visibility = 'hidden';
        el.style.height = '0';
        el.style.overflow = 'hidden';
        const parent = el.parentElement;
        if (parent && parent.classList.contains('field')) {
          parent.style.display = 'none';
        }
      });
    });
    
    console.log('✅ تم تبسيط نموذج الدفع - الحقول المتاحة فقط: الاسم الكامل، رقم الهاتف، العنوان');
  }

  // Add CSS to hide fields permanently
  function addHideStyles() {
    const style = document.createElement('style');
    style.id = 'checkout-simplify-styles';
    style.textContent = `
      /* Hide unnecessary fields */
      [name*="[company]"],
      [name*="company"],
      [name*="[address2]"],
      [name*="address2"],
      [name*="[city]"],
      [name*="city"],
      [name*="[province]"],
      [name*="province"],
      [name*="[state]"],
      [name*="state"],
      [name*="[zip]"],
      [name*="zip"],
      [name*="[postal]"],
      [name*="postal"],
      [name*="[country]"],
      [name*="country"],
      [name*="[email]"],
      [name*="email"],
      [name*="[last_name]"],
      [name*="last_name"],
      input[type="email"],
      .field--company,
      .field--address2,
      .field--city,
      .field--province,
      .field--state,
      .field--zip,
      .field--postal,
      .field--country,
      .field--email,
      .field--last-name,
      [data-address-field="company"],
      [data-address-field="address2"],
      [data-address-field="city"],
      [data-address-field="province"],
      [data-address-field="zip"],
      [data-address-field="country"],
      [data-address-field="last_name"],
      [data-checkout-field="email"],
      [data-checkout-field="last_name"],
      [class*="billing"],
      [id*="billing"],
      /* Hide Sign in links */
      a[href*="account"],
      a[href*="login"] {
        display: none !important;
        visibility: hidden !important;
        height: 0 !important;
        overflow: hidden !important;
        margin: 0 !important;
        padding: 0 !important;
        opacity: 0 !important;
      }
      
      /* Hide Contact section */
      section:has(input[type="email"]):not(:has(input[type="tel"])),
      div:has(input[type="email"]):not(:has(input[type="tel"])),
      [class*="contact"]:not([class*="delivery"]),
      [class*="Contact"]:not([class*="Delivery"]) {
        display: none !important;
      }
      
      /* Hide billing address */
      [class*="billing-address"],
      [id*="billing-address"],
      [class*="billing"] {
        display: none !important;
      }
    `;
    
    if (!document.getElementById('checkout-simplify-styles')) {
      document.head.appendChild(style);
    }
  }

  // Run immediately if DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      addHideStyles();
      initCheckoutCustomization();
    });
  } else {
    addHideStyles();
    initCheckoutCustomization();
  }

  // Watch for dynamic content changes (Shopify checkout loads dynamically)
  const observer = new MutationObserver(function() {
    initCheckoutCustomization();
  });

  if (document.body) {
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style']
    });
  }

  // Also run periodically to catch late-loading elements
  let attempts = 0;
  const maxAttempts = 50; // Increased attempts
  const interval = setInterval(function() {
    attempts++;
    initCheckoutCustomization();
    if (attempts >= maxAttempts) {
      clearInterval(interval);
    }
  }, 150); // Run more frequently

  // Also run on checkout step changes
  if (typeof window !== 'undefined' && window.Shopify && window.Shopify.checkout) {
    const originalStepChanged = window.Shopify.checkout.stepChanged;
    window.Shopify.checkout.stepChanged = function() {
      setTimeout(function() {
        addHideStyles();
        initCheckoutCustomization();
        if (originalStepChanged) originalStepChanged.apply(this, arguments);
      }, 100);
    };
  }

  // Run on any form changes
  document.addEventListener('change', function() {
    setTimeout(initCheckoutCustomization, 100);
  });

  // Run on any input events
  document.addEventListener('input', function() {
    setTimeout(initCheckoutCustomization, 50);
  });

  // Run on page visibility change
  document.addEventListener('visibilitychange', function() {
    if (!document.hidden) {
      setTimeout(initCheckoutCustomization, 100);
    }
  });

  // Run when page is fully loaded
  window.addEventListener('load', function() {
    setTimeout(function() {
      addHideStyles();
      initCheckoutCustomization();
    }, 500);
  });
})();